<template>
    <button v-bind="$attrs" class="px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"><i :class="icon" ></i>{{ buttonText }}</button>
</template>

<script setup>
const props = defineProps({
    buttonText: {
        type: String,
        default: () => "Submit",
    },
    icon: {
        type: String,
        default: () => ''
    }
})
</script>

<style scoped>

</style>